import PoblacionService from "common/services/PoblacionService"
import { normalizeString } from "common/utils/utils"
import { useCallback, useEffect, useState } from "react"

const mapResults = (results: $TSMigrationFixMe) =>
  results.map((res: $TSMigrationFixMe) => res.nombre)

const poblacionesService = new PoblacionService()

const mapPoblacionesToOptions = (poblaciones = []) =>
  poblaciones.map((poblacion) => ({
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: poblacion.nombre,
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    value: poblacion.nombre,
  }))

const getProvinciasOptionsFromPoblaciones = (
  poblaciones: $TSMigrationFixMe
) => {
  const provincias = new Map()

  poblaciones.forEach((provincia: $TSMigrationFixMe) => {
    const { provinciaNombre } = provincia

    if (!provincias.has(provinciaNombre)) {
      provincias.set(provinciaNombre, {
        nombre: provinciaNombre,
      })
    }
  })

  // @ts-expect-error TS(2345): Argument of type 'any[]' is not assignable to para...
  return mapPoblacionesToOptions([...provincias.values()])
}

const usePoblaciones = ({ initialCodigoPostal }: $TSMigrationFixMe = {}) => {
  const [poblaciones, setPoblaciones] = useState([])
  const [provinciasOptions, setProvinciasOptions] = useState([])
  const [filteredPoblaciones, setFilteredPoblaciones] = useState([])
  const [poblacionesOptions, setPoblacionesOptions] = useState([])

  const fetchPoblacionesByCodigoPostal = useCallback(
    async (codigoPostal: $TSMigrationFixMe) => {
      const resPoblaciones =
        await poblacionesService.getPoblacionesByCodigoPostal(codigoPostal)

      const poblacionesOptions = mapPoblacionesToOptions(resPoblaciones.data)
      const provinciasOptions = getProvinciasOptionsFromPoblaciones(
        resPoblaciones.data
      )

      // @ts-expect-error TS(2345): Argument of type '{ label: $TSFixMe; value: $TSFixMe; }[]' i...
      setPoblacionesOptions(poblacionesOptions)
      setPoblaciones(resPoblaciones.data)

      // @ts-expect-error TS(2345): Argument of type '{ label: $TSFixMe; value: $TSFixMe; }[]' i...
      setProvinciasOptions(provinciasOptions)

      return resPoblaciones.data
    },
    []
  )

  useEffect(() => {
    if (initialCodigoPostal?.length === 5) {
      fetchPoblacionesByCodigoPostal(initialCodigoPostal)
      return
    }

    setPoblacionesOptions([])
    setPoblaciones([])
    setProvinciasOptions([])
  }, [initialCodigoPostal, fetchPoblacionesByCodigoPostal])

  const filterPoblaciones = useCallback(
    (query: $TSMigrationFixMe) => {
      const search = query.toLowerCase()
      if (!search) return
      const filteredPoblaciones = poblaciones.filter((poblacion) => {
        // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
        return normalizeString(poblacion?.nombre.toLowerCase()).includes(
          normalizeString(search)
        )
      })
      setFilteredPoblaciones(mapResults(filteredPoblaciones).slice(0, 20))
    },
    [poblaciones]
  )

  const fetchPoblacionesByProvinciaId = useCallback(
    async (provinciaId: $TSMigrationFixMe) => {
      const resPoblaciones =
        await poblacionesService.getPoblacionesByProvinciaId(provinciaId)
      setPoblaciones(resPoblaciones.data?.items)
      setFilteredPoblaciones(mapResults(resPoblaciones.data?.items))
    },
    []
  )

  const getPoblacionByName = useCallback(
    (poblacionName: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
      return poblaciones.find((poblacion) => poblacion.nombre === poblacionName)
    },
    [poblaciones]
  )

  return {
    poblaciones,
    filteredPoblaciones,
    poblacionesOptions,
    provinciasOptions,
    getPoblacionByName,
    fetchPoblacionesByProvinciaId,
    filterPoblaciones,
    fetchPoblacionesByCodigoPostal,
  }
}

export default usePoblaciones
